import { Button, Tag } from 'antd';
import type { UploadView } from '../../../../../shared/features/uploads/uploads.api';
import { ReadinessDocumentAttach } from './ReadinessDocumentAttach';
import type { ReadinessItem } from '../../../jobs.api';

const DOCUMENT_KEY_PREFIX = 'document:';

/** The required document type id a `document:<id>` item names — null for every other, fixed item. */
function requiredDocumentTypeId(item: ReadinessItem): string | null {
  return item.key.startsWith(DOCUMENT_KEY_PREFIX) ? item.key.slice(DOCUMENT_KEY_PREFIX.length) : null;
}

function statusTag(item: ReadinessItem) {
  if (item.overridden) return <Tag color="warning">Overridden</Tag>;
  if (item.met) return <Tag color="success">Met</Tag>;
  return <Tag color="default">Not met</Tag>;
}

interface ReadinessItemRowProps {
  item: ReadinessItem;
  jobId: string;
  attachments: UploadView[];
  canManage: boolean;
  onOverride: (item: ReadinessItem) => void;
  onAttach: (requiredDocumentTypeId: string, uploadId: string) => Promise<void>;
}

/** One readiness checklist item (gitaumoses4/chukua#36): its status, an Override action while not met, and — for a document item — the attach control. */
export function ReadinessItemRow({ item, jobId, attachments, canManage, onOverride, onAttach }: ReadinessItemRowProps) {
  const documentTypeId = requiredDocumentTypeId(item);

  return (
    <li className="flex flex-col gap-2 rounded-lg border border-line p-4">
      <div className="flex items-center justify-between gap-3">
        <span className="text-sm font-medium text-fg">{item.label}</span>
        <div className="flex items-center gap-2">
          {statusTag(item)}
          {!item.met && (
            <Button size="small" disabled={!canManage} onClick={() => onOverride(item)}>
              Override
            </Button>
          )}
        </div>
      </div>
      {item.override && (
        <p className="text-xs text-muted">
          Overridden: {item.override.reason} ({new Date(item.override.occurredAt).toLocaleString()})
        </p>
      )}
      {!item.met && documentTypeId && (
        <ReadinessDocumentAttach jobId={jobId} attachments={attachments} disabled={!canManage} onAttach={(uploadId) => onAttach(documentTypeId, uploadId)} />
      )}
    </li>
  );
}
